import _ from 'lodash';
import { s3toPipedUrl } from '../helpers/urls';
import User from './user';
import { formatRelativeTime } from '@app/i18n/formatters/date';

class Message {
  constructor(message) {
    this.id = message._id || '';
    this._id = message._id || '';
    this.messageBody = message.body || '';
    this.redactionData = _.get(message, 'redactionData', []);
    this.redactionViewedEvents = _.get(message, 'redactionViewedEvents', []);
    this.type = message.type;
    this.chatId = message.chatId;
    this.createdAt = message.createdAt;
    this.delimitedAt = message.delimitedAt;
    this.messageGroup = message.messageGroup;
    this.additionalInfo = message.additionalInfo;
    this.deliveryStatus = message.deliveryStatus;

    this.setAuthor(message);
    this.formatTimestamp();

    this.isFile = message.isFile;
    this.mediaIndex = message.isFile ? message.mediaIndex : null;
    this.fileUrl = message.isFile ? s3toPipedUrl(message.fileUrl) : null;
    this.isAI = message.isAI;
    this.source = message.source;
    this.theLastMessage = message.theLastMessage;
    this.channel = message.channel;
    this.isEvent = message.isEvent;
    this.participants = message.participants || [];
    this.sentimentData = message.sentimentData || {};
    this.classifications = _.get(message, 'classifications', {});
    this.needsAttention = message.needsAttention || false;
    this.providerId = message.providerId;
    this.needsAction = message.needsAction || {};
    this.mediaInfo = message.mediaInfo;
    this.isFirstUnreadMessage = message.isFirstUnreadMessage || false;
    this.isInbound = message.isInbound;
    this.bodyPrefix = message?.bodyPrefix;
    this.hasDismissedNeedsAttention =
      message?.hasDismissedNeedsAttention || false;
    this.errorCode = message.errorCode;
    this.retryAttempted = message?.retryAttempted || false;
    this.wasScheduled = message?.wasScheduled || false;
  }

  setAuthor(message) {
    const author = message.author || message.authorId;
    if (!author) return;

    if (typeof author === 'string') {
      this.authorId = author;
      return;
    }
    this.author = new User(author);
  }

  setTranslation(translatedMessage) {
    this.additionalInfo = {
      ...this.additionalInfo,
      translatedMessage,
    };
  }

  formatTimestamp() {
    if (this.createdAt) {
      this.createdAtHuman = formatRelativeTime(this.createdAt);
    }
  }
}

export default Message;
